module.exports = __webpack_public_path__ + "img/wiki-card-bg.a0d6d9cb.png";